<template>
    <div id="app">
        <router-view/>
        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
    </div>
</template>

<script>
    import {getNewcurrent} from "./utils/interface";
    import * as RongIMLib from "@rongcloud/imlib-next";
    import chatDialog from "./components/chat/chatDialog";
    import {mapMutations, mapState} from "vuex";
    export default {
        name: 'App',
        components: {
            chatDialog
        },
        created() {
            //初始化融云
            RongIMLib.init({appkey: '6tnym1br6yci7'});


            //设置监听
            this.initListener();
        },
        destroyed() {
            //删除监听
            this.removeListener();
        },
        methods: {
            ...mapMutations(["isStorageUsermessage", "clearChatRecords"]),
            initListener() {
                let that = this
                // 连接状态监听器
                const Events = RongIMLib.Events
                /**
                 * 正在链接的事件状态
                 */
                RongIMLib.addEventListener(Events.CONNECTING, () => {
                    console.log('正在链接...')
                })
            
                /**
                 * 链接到服务器会触发这个事件
                 */
                RongIMLib.addEventListener(Events.CONNECTED, () => {
                    console.log('连接成功')
                })
            
                /**
                 * 手动调用 disconnect 方法或者用户被踢下线 会触发这个事件
                 */
                RongIMLib.addEventListener(Events.DISCONNECT, () => {
                    console.log('连接中断，需要业务层进行重连处理')
                })
            
                /**
                 * 链接出问题时，内部进行重新链接，会出发这个事件
                 */
                RongIMLib.addEventListener(Events.SUSPEND, () => {
                    console.log('链接中断，SDK 会尝试重连，业务层无需关心')
                })
                // 消息监听器
                RongIMLib.addEventListener(Events.MESSAGES, function (messages) {
                    console.log(messages);
                    messages.messages.forEach((message, index) => {
                        if (message.senderUserId !== that.$store.state.userMessages.uuid) {
                            let type = 1;
                            if (message.messageType.indexOf("Img") != -1) {
                                type = 2;
                            }
                            if (message.messageType.indexOf("File") != -1) {
                                type = 3;
                            }
                            let say = { //自定义消息组件所需参数
                                type: type,
                                css: 'left',
                                txt: message.content,
                                date: '',
                                headImg: ''
                            }
                            if (!that.chatRecord[message.targetId]) {
                                that.clearChatRecords(message.targetId);
                            }
                            that.chatRecord[message.targetId].push(say);
                            that.$set(that.chatRecord, that.chatRecord[message.targetId], say);
                        } else {
                            messages.messages.splice(index, 1);
                        }
                    });
                    if (messages.messages.length > 0 && !that.$store.state.isChatting) {
                      //获取会话未读数
                      const includeMuted = false
                      const conversationTypes = [RongIMLib.ConversationType.PRIVATE]
                      RongIMLib.getTotalUnreadCount(includeMuted, conversationTypes).then(res => {
                        if (res.code === 0) {
                          that.$store.state.unReadMsgCount = res.data;
                        } else {
                          console.log(res.code, res.msg)
                        }
                      }).catch(error => {
                        console.log(error)
                      })
                        that.$notify.info({
                            title: '消息',
                            message: '有新的消息，请及时查看！',
                            duration: 5000,
                            position: 'bottom-right',
                            onClick(){
                                getNewcurrent()
                                    .then((res) => {
                                        that.isStorageUsermessage(res);
                                        let user = that.$store.state.userMessages;
                                        that.$refs.chatDialogRef.initReply(user.uuid,user.name,user.headUrl);
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                            }
                        });
                    }
                });
            },
            
            //清除事件监听
            removeListener() {
                const Events = RongIMLib.Events;
                RongIMLib.removeEventListeners(Events.MESSAGES);
            }
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        height: 100%;
    }

    a {
        text-decoration: none;
    }
    input,
    textarea,
    select,
    a:focus {
        outline: none;
    }
    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }

    li {
        box-sizing: border-box;
    }

    div {
        box-sizing: border-box;
    }

    html, body {
        margin: 0;
        padding: 0;
        width: 100%;
       height: 100%;
        background: #eaf1ff;;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue